var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 217,
    viewBox: "0 0 533 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2959_995",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.382668 63.4114C44.0166 33.1333 99.6097 12.5137 160.132 4.15999C220.654 -4.19371 283.387 0.0937022 340.397 16.4801C397.408 32.8664 446.135 60.6158 480.418 96.219C514.701 131.822 533 173.68 533 216.5L221 216.5L0.382668 63.4114Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.382668 63.4114C44.0166 33.1333 99.6097 12.5137 160.132 4.15999C220.654 -4.19371 283.387 0.0937022 340.397 16.4801C397.408 32.8664 446.135 60.6158 480.418 96.219C514.701 131.822 533 173.68 533 216.5L221 216.5L0.382668 63.4114Z",
    stroke: "#2051A3",
    strokeWidth: 2,
    strokeDasharray: "7 7",
    mask: "url(#path-1-inside-1_2959_995)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondLine);
export default __webpack_public_path__ + "static/media/second-line.56bd97202094cdf7ccbc20f923e36fcc.svg";
export { ForwardRef as ReactComponent };